import { AuthService, useAuth } from '@yubi/yb-module-auth';
import classNames from 'classnames';
import Grid from 'components/core/Grid';
import Header from 'components/Header';
import useIsHeaderDisabledRoute from 'components/hooks/useIsHeaderDisabledRoute';
import useIsPublicRoute from 'components/hooks/useIsPublicRoute';
import React, { Suspense, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useRoutes } from 'react-router-dom';
import styled from 'styled-components';
import { loadLoggedInUser } from '../store/authed';
import ROUTE_CONFIG from './config';
import { IRouteConfig } from './types';
import { fetchLoggedInUserDetails } from './utils';

const Wrap = styled(Grid)`
    .page-wrap {
        height: '100%';
    }
    .content-header {
        flex-grow: 1;
        height: calc(100% - 73px);
        overflow-y: auto;
        max-height: calc(100% - 73px);
    }
    .content-no-header {
        height: '100%';
    }
`;

const removeNonAvailableRoutes = (routes: IRouteConfig[]) => {
    const availableRoutes = routes.filter((route) => {
        const activeActor = AuthService.getActiveActor()!;
        if (!route.allowedActors) return true;
        if (Array.isArray(route.allowedActors) && route.allowedActors.includes(activeActor))
            return true;
        return false;
    });

    return availableRoutes.map((route) => {
        if (route.children!?.length > 0) {
            route.children = removeNonAvailableRoutes(route.children!);
        }
        return { ...route };
    });
};

const AppContainer: React.FC = () => {
    const dispatch = useDispatch();

    const isPublicRoute = useIsPublicRoute();
    const isHeaderDisabledRoute = useIsHeaderDisabledRoute();

    useEffect(() => {
        if (!isPublicRoute) {
            // initiate app load logic
            fetchLoggedInUserDetails().then((res) => dispatch(loadLoggedInUser(res)));
        }
    }, [isPublicRoute]);
    return (
        <Wrap item container direction="column" className="page-wrap">
            {!isHeaderDisabledRoute && (
                <Grid item container style={{ height: 73 }} className="header-wrap">
                    <Header />
                </Grid>
            )}
            <Grid
                className={classNames({
                    'content-header': !isHeaderDisabledRoute,
                    'content-no-header': isHeaderDisabledRoute,
                })}
            >
                <Outlet />
            </Grid>
        </Wrap>
    );
};

const AppRouter: React.FC<any> = () => {
    const {} = useAuth();
    const AVAILABLE_ROUTES = useMemo(() => {
        return [
            {
                path: '/',
                element: <AppContainer />,
                children: removeNonAvailableRoutes(ROUTE_CONFIG),
            },
        ];
    }, [ROUTE_CONFIG]);
    const children = useRoutes(AVAILABLE_ROUTES as any);
    return <Suspense fallback={<p> Loading...</p>}>{children}</Suspense>;
};

export default AppRouter;
